type ParseStepFromHistoryParams = {
  finalStepIndex: number;
  formId: string;
  initialStepIndex?: number;
};

/**
 * Parse a step index from the browser history
 */
function parseStepIndexFromHistory({
  finalStepIndex,
  formId,
  initialStepIndex = 0,
}: ParseStepFromHistoryParams) {
  // This is a noop if the browser history has no state. No history state means the user has not navigated the form yet
  if (history.state?.formId !== formId || !history.state?.stepIndex) {
    return initialStepIndex;
  }

  const parsedStepIndex = Number(history.state.stepIndex);

  if (Number.isNaN(parsedStepIndex)) {
    return initialStepIndex;
  }

  const boundedStepIndex = Math.min(
    Math.max(parsedStepIndex, initialStepIndex),
    finalStepIndex,
  );

  return boundedStepIndex;
}

export { parseStepIndexFromHistory };
